import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-citySearch';
	$(base, context).each(function(){
		var component = $(this);
		var positions = component.find('.b-cityList').find('.b-cityList-city');

		var inputSearch = component.find('.b-searchForm-input');
		inputSearch.val('').on('input', function(e){
			var term = this.value.toLowerCase();

			positions.map(function(){
				var words = this.innerText.toLowerCase().split(/[-\s,.]+/);

				return {
					el: this,
					hidden: !words.some(function(word){
						return word.indexOf(term) === 0;
					}),
				};
			}).each(function() {
				this.el.hidden = this.hidden;
			});
		});
	});
});
